export default "__VITE_ASSET__gHpbJlod__"